import { AssignationStatus, VehicleType } from "@daytrip/legacy-enums";
import { isUndefinedOrNull } from "@daytrip/utils";
import { Exclude, Expose, Transform, Type } from "class-transformer";
import { IsArray, IsDate, IsDefined, IsInt, IsString, IsUUID, ValidateNested } from "class-validator";
import { v4 as uuid } from "uuid";

import { AssignationAutomaticEmail } from "./AssignationAutomaticEmail";

@Exclude()
export class SimpleOrderWithAssignationsAssignation {
    @IsUUID("4")
    @IsDefined()
    @Expose()
    public assignationId: string = uuid();

    @IsUUID("4")
    @IsDefined()
    @Expose()
    public userId: string;

    @IsString()
    @IsDefined()
    @Expose()
    public userFullName: string;

    @IsInt()
    @IsDefined()
    @Expose()
    public vehicleType: VehicleType;

    // the Assignation is accepted: if the vehicle is undefined, acceptation note is defined and contrariwise
    @IsString()
    @IsDefined()
    @Expose()
    public vehicleName?: string;

    @IsString()
    @Expose()
    @Transform((value) => (isUndefinedOrNull(value) ? undefined : value))
    public acceptationNote?: string;

    @IsDefined()
    @Expose()
    @Type(() => Date)
    public createdAt: Date;

    @IsDate()
    @Expose()
    @Transform((value) => (isUndefinedOrNull(value) ? undefined : value))
    public acceptedAt?: Date;

    @IsDate()
    @Expose()
    @Transform((value) => (isUndefinedOrNull(value) ? undefined : value))
    public declinedAt?: Date;

    @IsDate()
    @Expose()
    @Transform((value) => (isUndefinedOrNull(value) ? undefined : value))
    public cancelledAt?: Date;

    @IsString()
    @Expose()
    @Transform((value) => (isUndefinedOrNull(value) ? undefined : value))
    public reason?: string;

    @IsArray()
    @IsDefined()
    @ValidateNested()
    @Expose()
    @Type(() => AssignationAutomaticEmail)
    public automaticEmails: Array<AssignationAutomaticEmail> = [];

    public get status(): AssignationStatus {
        if (!isUndefinedOrNull(this.cancelledAt)) {
            return AssignationStatus.Cancelled;
        }

        if (!isUndefinedOrNull(this.declinedAt)) {
            return AssignationStatus.Declined;
        }

        if (!isUndefinedOrNull(this.acceptedAt)) {
            return AssignationStatus.Accepted;
        }

        return AssignationStatus.Pending;
    }
}
